function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1",
  transform: "translate(0 -0.003)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_1484686577040"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M90.29,45.62c.51.32.87.29,1.88-.48l-.32-1.84c-.15-1.09-.43-1.7.95-1.92.36.44.21-.08.31.65.16,1.08-.58,1.01-.71,1.06a2.1,2.1,0,0,0,1.44.38,1.227,1.227,0,0,0-.42.03l-.17.91a.743.743,0,0,0,1.24.31c-.8-.56-.79-.97-.8-1.04l.62-1.33c.04-.04.1-.09.16-.14.36.14.31-.3.49.65a7.658,7.658,0,0,0,2.85-.59,1.8,1.8,0,0,1-.09-.39,2.3,2.3,0,0,0-.15-.32l-6.76-12.4c-.24-.37.09.16-.44-.7-2.77.06-9.85.06-12.62-.03-.49,11.29-1.26,22.87-1.67,33.62h9.61c.39-1.67.23-13.24.57-15.72.12-.89-.01-1.76.07-2.64a22.828,22.828,0,0,0,.2-2.52c.53.21.21.05.53.51l2.06,4c.18.32.26.4.48.79.48.88.62-.02.69-.85Z",
  fill: "#00aeed",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M106.85,24.05c0-1.32.17-1.04.77-1.86,1.38.15,2.01.34,1.89,1.91-.96.95-1.68,1.05-2.66-.05Zm-1.1-.24c-.23-2.29,1.6-4.15,3.37-2.73-1.28.14-1.84-.2-2.48.71C106.12,22.55,106.24,23.2,105.75,23.81Zm3.68-14.06c2.34.1,3.5,3.62,2.06,4.36-1.04.54-2.22-.5-2.48-1.26-.39-1.17.19-2.24.42-3.1Zm-7.09-7.34c.42.2.52-.89,1.74-1.36-.16.57-.56,1.07-1.12,2.81-1.21,3.76.5,3.83-1.17,5.56-3.73,3.86-2.69,5.55-2.2,8.15-1.42,2.06-3.8,5.2-2.13,8.3.73,1.35.27,2.06.83,2.77l16.45-5.03,1.35-2.32c.31-.68.39-.44.46-1.43l-.48-.52a1.967,1.967,0,0,1,1.62-.92c.98-.1.88.22,1.7.29l1.2.4.31-.47c.01-.02.13.03.24-.39.02.98-.08.17.19.65.21.37.17.21.39.43.44-.35.8-.36,1.55-.02l1.29.7c.55-.27.62.31.47-.71.16,1.34,0,.26.32.69-.27-2.15-1.72-2.96-3.88-3.54a7.629,7.629,0,0,0-2.5-4.97c-.73-.57-2.06-.87-2.51-1.28a22.488,22.488,0,0,0-1.45-2.11c-3.34-3.34-7.73-4.99-8.44-5.52-.49-.36-.23-.12-.58-.62a14.483,14.483,0,0,1,6.21,2.26l3.42,2.87a3.368,3.368,0,0,0,1.03.94,9.364,9.364,0,0,0-2.8-3.14,26.73,26.73,0,0,0-3.5-2.57c-1.98-1.13-6.99-3.43-8.01.1Z",
  fill: "#d1e7e4",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M60.73,62.05H73.15c-2.24-3.54-11.7-16.53-11.7-18.37.66-.25,10.78-13.78,11.91-15.25H67.09c-2.17,0-3.66.06-5.8.06-.43.82-.68.9-1.16,1.75-2.67,3.83-5.34,7.58-8.09,11.34-2.47,3.13-2.01,2.58-.34,5.15,1.91,3.26,7.44,12.26,9.03,15.32Z",
  fill: "#04acec",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M38.04,61.43v.62h9.61c.73,0,.8-.01,1.22,0,.02-.21.02-.35.04-.6.66-9.39.92-23.64,1.67-33.17-3.81-.01-6.29,0-10.74-.05-.19,10.6-1.61,28.72-1.8,33.2Z",
  fill: "#00aeed",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M240.14,29.89c2.36-.01,4.83-.05,7.25-.03l.06,13.61h-7.31V29.89ZM237,30.93v11.7c0,4.58,2.5,3.55,10.45,3.55V58.71h-7.1V51.4h-3.14v7.73c0,1.88,1.98,2.3,3.56,2.3h6.27c1.87,0,3.55-.46,3.55-2.3V29.47c0-.86-1.02-2.09-1.67-2.09H238.68c-1.25,0-1.68,2.14-1.68,3.55Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M96.49,32.58c5.96.05,7.26-3.09,10.07-3.47a6.627,6.627,0,0,1-1.2,1.86c-1.87,2.86-.02,2.8-5.52,4.17,3.02,1.69,11.88,1.16,15.47.34a29.453,29.453,0,0,0,6.43-2.15c1.7-.8,4.25-2.74,4.78-3.91-.27-.25.19-.23-1.09.03a12.838,12.838,0,0,1-4.01.02c-1.47-.21-3.68-.32-4.85-1.04,1.29-.58,3.48-.14,6.54-1.88,2.59-1.48,3.14-3.41,4.84-3.39l-.17-.62a76.308,76.308,0,0,0-17.39,2.58c-2.69.71-13.32,4.03-14.62,5.4l.72,2.06Z",
  fill: "#fcfcfe",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M173.89,61.43h2.92c.15-.65.25-1.56.36-2.15l1.1-6.42c.16-.64.3-1.47.39-2.12l.71-4.3a14.519,14.519,0,0,0,.39-2.12l2.9-16.94h-2.92l-1.1,6.84c-.74,3.74-1.41,9.66-2.16,13.72-.22,1.22-.29,2.31-.52,3.44a23.189,23.189,0,0,0-.4,3.57l-3.67-22.44c-1.11-6.08.27-5.13-3.86-5.13.12,1.34.47,2.61.66,4.15.09.71.29,1.24.45,2.06l1.45,8.58c.13.56.24,1.55.34,2.16Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M89.76,46.5c.41.84,1.22,2.6,1.75,3.47l4.8,8.16a21.144,21.144,0,0,1,1.92,3.92h12.54c0-1.36-.27-3.17.21-4.37-3.02-.28-2.63-.01-4.94,1.12-1.75.86-2.57,1.45-4.37.28-.63-.4-.68-.61-1.35-.84-.92.64-.24.71-1.46,1.18-2.13-.73-2.73-3.36-1.74-6.02l5.29-.06c.63-.91,1.46-1.28,1.86-2.15-1.22-1.71-1.27-1.11-1.39-4.07l-.6.08-.19,3.04c-.13-.71-1.06-1.89-1.35-2.82-1.04.02-3.28-.13-3.62-.93l-.4-1.12c-.28-.56-.27-.44-.76-.69-.99-.49-1.17-.25-1.69-1.27l.69-.55c-.18-.95-.13-.51-.49-.65-.06.05-.12.1-.16.14l-.62,1.33c.01.07,0,.48.8,1.04a.743.743,0,0,1-1.24-.31l.17-.91a1.227,1.227,0,0,1,.42-.03,2.1,2.1,0,0,1-1.44-.38c.13-.05.87.02.71-1.06-.1-.73.05-.21-.31-.65-1.38.22-1.1.83-.95,1.92l.32,1.84c-1.01.77-1.37.8-1.88.48C90.2,46.78,90.03,45.49,89.76,46.5Z",
  fill: "#04acec",
  stroke: "#00aeed",
  strokeMiterlimit: 22.926,
  strokeWidth: 0.27,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M105.08,39.29a7.894,7.894,0,0,1,1.25,3.37c.4,2.24.06,1.91-1.43,2.87-1.97,1.26-5.06,2.08-7.51.85-.51-.88,0-1.21-.86-1.84-.78-.56-1.2-.3-1.71-1.04,1.48-.9,2.19.58,5.03-2.58.75-.83,2.83-3.65,3.6-4.06l.79.83c.03.04.13.18.16.23a4.5,4.5,0,0,1,.68,1.37Zm1.83,4.7a10.614,10.614,0,0,0-.91-4.11c-.6-1.31-1.32-2.05-1.86-3.07,1.26-.02,1.39.08,1.92.93,1.04,1.68,1.89,4.51.85,6.25Zm19.06-4.34-4.29-5.52c.93-.07,2.16,1.43,2.73,2.18C124.94,37,126.04,38.6,125.97,39.65ZM128.74,33a9.281,9.281,0,0,0,1.51-1.17c.86-.8.63-.91,1.52-1.37l-.11,1.21-.03.73a.494.494,0,0,0,.15.03c.88.22.61-.12.83.48a2.726,2.726,0,0,1-1.45,3.57,30.838,30.838,0,0,1-5.09,1.72c-1.23-2.06-1.88-3.33-3.62-4.48a1.239,1.239,0,0,1,1.1-.83c.27-.04,3.42.23,5.19.11Zm-2.22-3.58c-.53,1.17-3.08,3.11-4.78,3.91a29.454,29.454,0,0,1-6.43,2.15c-3.59.82-12.45,1.35-15.47-.34a4.4,4.4,0,0,1-3.35-2.56l-.72-2.06c1.3-1.37,11.93-4.69,14.62-5.4a76.308,76.308,0,0,1,17.39-2.58l.17.62c1.15,1.98.07,5.55-1.43,6.26ZM102.34,2.41c1.02-3.53,6.03-1.23,8.01-.1a26.73,26.73,0,0,1,3.5,2.57,9.364,9.364,0,0,1,2.8,3.14c.32.37.15.52.7.88.96.61,4.97,1.23,5.07,6.24a5.028,5.028,0,0,1,3.84,2.2,6.7,6.7,0,0,1,1.38,4.67l-1.58.16c-4.03.05-7.65,1.09-11.32,1.44L98.29,28.64l-2.54,1.22c-.17-1.39.36-2.02.07-3.21a7.776,7.776,0,0,1-.48-2.82c-.01-5.05,3.03-5.04,2.38-7.42-.9-3.3.85-4.86,2.89-7.2-.4-1.96.01-6.11,1.73-6.8ZM97.81,42.27a7.658,7.658,0,0,1-2.85.59l-.69.55c.52,1.02.7.78,1.69,1.27.49.25.48.13.76.69l.4,1.12c.34.8,2.58.95,3.62.93l1.54-.22.6-.08c.12,2.96.17,2.36,1.39,4.07-.4.87-1.23,1.24-1.86,2.15l-.31.55a5.053,5.053,0,0,0,2.44,2.28,9.655,9.655,0,0,0,2.63.92c.04.01.43.18.46.19l.28.16c-.87.36-2.09.92-2.93,1.33-1.9.94-1.33.44-2.93.19l-.38.12c1.8,1.17,2.62.58,4.37-.28,2.31-1.13,1.92-1.4,4.94-1.12l-.21-.45a21.155,21.155,0,0,1-4.54-.82c-1.86-1.06-2.47-.71-3.6-2.5.42-1.06,1.55-1.53,2.13-2.47l.67.19.07-.18c-.9-1.05-1.09-.32-1.78-1.77a3.843,3.843,0,0,1-.33-2.74c.39-.63,3.96-1.44,4.41-3.72.5-2.58-.91-4.49-1.6-6.21l3.32.07c.49.65.79,1.06,1.26,1.78l.98,1.48c.43.53-.12.05.22.2l.18-.02c-.08-1.02-1.59-2.64-2.05-3.62l1-.22a11.794,11.794,0,0,1,1.51,2.37c.49,0,.46.16.37-.22l-1.26-2.33c1.44-.27,2.94-.48,4.42-.8l3.43-.89c.54,0,.06-.1.42.11.19.15.08.01.39.41a4.652,4.652,0,0,1,.32.5,3.167,3.167,0,0,0,.8.98l-.08-.44c-.27-.84-.62-.98-.87-1.82,1.06-.08,1.06.28,2.46,2.1,1.33,1.73,4.76,6.09,5.08,8.16-.83-.34-.31-.32-1-.64l-.17.18c.18.77.81.75,1.5,1.31a4.54,4.54,0,0,1,1.29,1.56,11.329,11.329,0,0,1,2.14,2.47c1.3,1.67-1.7,3.27-2.19,4.06l.16.21a21.8,21.8,0,0,1,1.99-1.45l.26-.72c1.22.47,3.14,3.03,3.75,4.44l2.92-.39a2.764,2.764,0,0,1-.87,1.98,5.15,5.15,0,0,1-.75.72c-.53.43-.3.36-.87.48-.42.66-.6.67-1.5,1.11-3.99,1.94-2.01.77-5.18-.2v.04c.43.98-.11.28.82.87.27.17.55.32.92.53,1.3.72.79.35,2.02.06.32-.3,2.72-1.39,3.54-2.08l1.06-1.05c.74-.05,1.87-2.11,1.25-2.72-.94-.45-1.98,0-3.13,0a5.012,5.012,0,0,0-1.14-1.79,12.174,12.174,0,0,0-1.37-1.63c-2.78-1.63.96-.83-2.67-4.54l-.62-.6c-.09-.49-.18-.48-.84-1.1-1.63-1.54-.23-1.75-2.14-4.34-.28-.38-.76-.76-.88-1.15a2.506,2.506,0,0,1,.25-1.77c.32-.36,2.78-.98,3.36-1.25.82-.68.15-.11.9-.37,1.02-.34,1.77-.65,2.04-1.67.33-1.26.35-2.78-.8-3.6.12-.68.24-1.6-.25-2.09-.47-.12-.54.62-1.28.92-.98,2.03-3.19,2.46-6.06,1.8.77-1.14,5.69-4.78,4.33-8.71-.32-.9-.69-1.16-.77-1.95-.13-1.26.24-2.2-1.14-4.29-2.33-3.55-3.87-1.45-4.28-3.87-.77-4.62-4.32-3.75-5.57-5.92a5.139,5.139,0,0,0-.32-.51,22.33,22.33,0,0,0-5.08-4.54c-.34-.24-.46-.35-.73-.52-1.47-.92-5.67-2.72-7.34-1.86l-1.13.96a7.6,7.6,0,0,0-2.42,6.35c.04,2.78-.04,1.39-1.74,3.7a5.909,5.909,0,0,0-.77,6.33c-1.07.71-2.3,3.1-2.63,4.67a8.5,8.5,0,0,0,.12,3.48c1.06,3.89-1.3,5.79,2.15,8.71a9.271,9.271,0,0,0,5.59,1.93c-.23,1-1.18,1.67-2.33,3.11a9.417,9.417,0,0,1-2.69,2.8Z",
  fill: "#0a0e11",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M227.18,37.83h1.26V60.8c0,.93.97.63,3.13.63V27.38h-2.51l-1.88,10.45Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M186.84,60.8c0,.48.15.63.63.63h2.51V27.38h-3.14Z",
  fill: "#263996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M130.62,30.6c.74-.3.81-1.04,1.28-.92.49.49.37,1.41.25,2.09,1.15.82,1.13,2.34.8,3.6-.27,1.02-1.02,1.33-2.04,1.67-.75.26-.08-.31-.9.37h.61l.03,8.58c-.11,1.43.05.63-.39,1.03l.62.6c3.63,3.71-.11,2.91,2.67,4.54V30.1c2.51-.06,5-.01,7.52-.05v7.57h3.14c0-2.23-.01-4.46,0-6.69.03-4.54-1.26-3.49-10.03-3.55-2.95-.02-3.56.27-3.56,3.22Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M129.67,53.75c.49-.79,3.49-2.39,2.19-4.06-.29,1.11-.17,1.49-1.03,2.1a30.862,30.862,0,0,1-2.91-5.68c.87.29.98.64,1.8,1.11a4.54,4.54,0,0,0-1.29-1.56c-.69-.56-1.32-.54-1.5-1.31-1.11.04-.36.06-2.2,1.38a13.7,13.7,0,0,1-2.29,1.22c.54,7.81-1.03,7.19-1.35,10.21,5.18-.38,6.23-2.6,8.58-3.41Z",
  fill: "#e2bd4a",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M112.99,38.83a23.9,23.9,0,0,1,2.14,5.67,26.9,26.9,0,0,0,5.61-.47,11.434,11.434,0,0,0,3.98-2.23l-.32-.47c-.04.04-.1.05-.12.12l-1.39,1.05c-.47-.34-.64-1.08-.9-1.71-.27-.66-.56-1.3-.82-1.85-.39-.81-1.48-3.35-1.17-4.02-.36-.21.12-.11-.42-.11l-3.43.89c-1.48.32-2.98.53-4.42.8l1.26,2.33Z",
  fill: "#d1e7e4",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M108.94,49.04a23.9,23.9,0,0,1,.52-2.44,12.778,12.778,0,0,0-.01-3.09c-.16-1.37-1.11-3.78-1.07-4.74l1.82-.41c.84,2.12,2.38,4.26,3.04,6.62.98,3.52-.92,4.48-4.3,4.06Zm-3.44,2.41c1.6.04,2.71.86,4.98.5,6.81-1.09,2.44-8.82,1.5-11.41-.34-.15.21.33-.22-.2l-.98-1.48c-.47-.72-.77-1.13-1.26-1.78l-3.32-.07c.69,1.72,2.1,3.63,1.6,6.21-.45,2.28-4.02,3.09-4.41,3.72a3.843,3.843,0,0,0,.33,2.74c.69,1.45.88.72,1.78,1.77Z",
  fill: "#8a5d42",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M106.23,56.41a21.155,21.155,0,0,0,4.54.82c.09-.7.66-.54,1.47-.54s1.62.06,2.44.06a10.213,10.213,0,0,0,2.46-6.39c2.36-.66,2.5-.33,2.54-1.46-.39-.37-.01-.5-2.01-.36a9.581,9.581,0,0,1-2.13.05,6.826,6.826,0,0,1-1.2,2.65,5.074,5.074,0,0,1-2.5,1.43,13.039,13.039,0,0,1-5.25.13c-.93-.13-.52.05-1.4-.57l-.5.39c-.76.51-.73.36-1.28,1.23,2.53,2.97,2.98,1.41,2.82,2.56Z",
  fill: "#d1ac3e",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M137.54,58.69l-.66.66c-.82.69-3.22,1.78-3.54,2.08h5.85c5.95.01,5.25-1.04,5.25-6.21,0-2.06.03-3.87,0-5.06-1.71.01-2.59.01-3.27.02-.02.8.09,2.33-.1,8.53l-2.49-.02C137.76,58.68,138.14,58.7,137.54,58.69Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M118.58,57.26c1.12-3.44,1.7-2.97,2.02-7.73.1-1.51-.13-1.9,1.25-2.18l.37,1.41a19.647,19.647,0,0,1-1.25,7.39C120.49,57.5,120.08,57.42,118.58,57.26Zm1.2-12.54,1.98-.49.48-.14.83,2.1a9.27,9.27,0,0,1-2.49.93,5.215,5.215,0,0,1-.8-2.4Zm-4.29,3.07-.15-1.61a11.182,11.182,0,0,0-.11-1.19l3.9-.16a6.106,6.106,0,0,1,.79,2.59Zm7.42-3.48-.24-.62a18.139,18.139,0,0,0,2.5-1.43l.72,1.29.37.33a8.747,8.747,0,0,1-2.67,2,3.809,3.809,0,0,1-.68-1.57Zm-1.4-7.5a18.518,18.518,0,0,0,2.12,3.41,3.7,3.7,0,0,1,.77,1.11l.32.47a11.434,11.434,0,0,1-3.98,2.23,26.9,26.9,0,0,1-5.61.47,23.9,23.9,0,0,0-2.14-5.67c.09.38.12.22-.37.22.99,2.38,3.05,5.77,2.01,9.11a40.9,40.9,0,0,0-.75-4.24l-1.36-3.06a1.137,1.137,0,0,0-.36-.34l-.18.02c.94,2.59,5.31,10.32-1.5,11.41-2.27.36-3.38-.46-4.98-.5l-.07.18c1.49,1.08,6.14,1.58,8.49-1.05.86-.96.78-1.66,1.37-2.41l4.98-.34a16.955,16.955,0,0,1-2.28,9.33c-1.46.61-5.41.31-7.22.07l.21.45,3.34.2c1.33-.01,2.65,0,3.98,0a25.548,25.548,0,0,0,6.68-1.05c.82,1.22,1.97,1.75,3.23,2.63.88.62.92.61,1.37.51v-.04c-.19-.46-1.54-1.1-2.08-1.44a9.765,9.765,0,0,1-2.04-1.81,46.9,46.9,0,0,0,4.37-2.72l-.16-.21c-2.35.81-3.4,3.03-8.58,3.41.32-3.02,1.89-2.4,1.35-10.21a13.7,13.7,0,0,0,2.29-1.22c1.84-1.32,1.09-1.34,2.2-1.38l.17-.18-5.67-7.8.08.44Z",
  fill: "#170402",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M102.34,2.41c-1.72.69-2.13,4.84-1.73,6.8-2.04,2.34-3.79,3.9-2.89,7.2.65,2.38-2.39,2.37-2.38,7.42a7.776,7.776,0,0,0,.48,2.82c.29,1.19-.24,1.82-.07,3.21l2.54-1.22c-.56-.71-.1-1.42-.83-2.77-1.67-3.1.71-6.24,2.13-8.3-.49-2.6-1.53-4.29,2.2-8.15,1.67-1.73-.04-1.8,1.17-5.56.56-1.74.96-2.24,1.12-2.81-1.22.47-1.32,1.56-1.74,1.36Z",
  fill: "#aabcbb",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M125.35,19.99l.71,2.18,1.58-.16a6.7,6.7,0,0,0-1.38-4.67,5.028,5.028,0,0,0-3.84-2.2c-.1-5.01-4.11-5.63-5.07-6.24-.55-.36-.38-.51-.7-.88a3.368,3.368,0,0,1-1.03-.94L112.2,4.21a14.483,14.483,0,0,0-6.21-2.26c.35.5.09.26.58.62.71.53,5.1,2.18,8.44,5.52a22.487,22.487,0,0,1,1.45,2.11c.45.41,1.78.71,2.51,1.28a7.629,7.629,0,0,1,2.5,4.97c2.16.58,3.61,1.39,3.88,3.54Z",
  fill: "#f5f6f6",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M105.43,51.63l-.67-.19c-.58.94-1.71,1.41-2.13,2.47,1.13,1.79,1.74,1.44,3.6,2.5.16-1.15-.29.41-2.82-2.56.55-.87.52-.72,1.28-1.23l.5-.39c.88.62.47.44,1.4.57a13.039,13.039,0,0,0,5.25-.13,5.074,5.074,0,0,0,2.5-1.43,6.826,6.826,0,0,0,1.2-2.65,9.581,9.581,0,0,0,2.13-.05c2-.14,1.62-.01,2.01.36-.04,1.13-.18.8-2.54,1.46a10.213,10.213,0,0,1-2.46,6.39c-.82,0-1.63-.06-2.44-.06s-1.38-.16-1.47.54c1.81.24,5.76.54,7.22-.07a16.955,16.955,0,0,0,2.28-9.33l-4.98.34c-.59.75-.51,1.45-1.37,2.41-2.35,2.63-7,2.13-8.49,1.05Z",
  fill: "#e2bd4a",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M139.82,68.74a32.124,32.124,0,0,1,.84,3.97h-1.68A13.5,13.5,0,0,1,139.82,68.74Zm-4.39,2.51c-1.76,0-3.16.76-2.3-2.93h2.3c.33,1.24.42-.22.42,1.88C135.85,70.94,135.45,70.49,135.43,71.25Zm-3.13,5.22h.62V72.5c2.23,0,1.64.05,2.97,3.09.4.91-.04.88,1.63.88.91,0,.68-1.16,1.05-2.72h2.29a6.608,6.608,0,0,1,.63,2.72h1.05c-.13-.53-.14-.4-.29-.97l-2.01-8.22h-1.05a20.567,20.567,0,0,1-.92,4.3l-.96,4.47c-.74-.55-.53-.99-.95-1.98a10,10,0,0,1-.93-1.99c1.5-.4,1.26-1.7,1.26-3.13,0-2.13-2.29-1.67-4.39-1.67-.31,1.46,0,6.81,0,9.19Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M94.82,43.5c.51.74.93.48,1.71,1.04.86.63.35.96.86,1.84,2.45,1.23,5.54.41,7.51-.85,1.49-.96,1.83-.63,1.43-2.87a7.894,7.894,0,0,0-1.25-3.37,30.31,30.31,0,0,1,1.04,4.3,1.55,1.55,0,0,1-.13-.17,1.11,1.11,0,0,1-.12-.16l-.12-.15a2.252,2.252,0,0,1-.25-.46c-.37-.8-.28-1.34-1.21-2.06a13.866,13.866,0,0,0-3.73,2.07c-1.58,1.03-2.45,2.13-3.26,2.46a4.089,4.089,0,0,0-2.07-1.58c-.31-.08.08-.04-.41-.04Z",
  fill: "#cee4e2",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M202.31,76.68h1.46V71.25l2.09,5.43h1.47v-9.4c-2.19,0-1.45-.01-1.56.5a11.668,11.668,0,0,0,.05,3.09v.14c-.02.68-.04.68-.37,1.07-.46-1.95-1.36-3.46-1.68-4.8h-1.46v9.4Z",
  fill: "#2d3b94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M190.61,76.68h1.46l.42-4.81c.38,1.64,1.27,3.11,1.67,4.81h1.25V67.9c0-.8-.06-.07.21-.62h-1.46l-.42,4.8c-.08-.94-1.32-3.28-1.67-4.8h-1.46Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M102.05,58.96c1.6.25,1.03.75,2.93-.19.84-.41,2.06-.97,2.93-1.33l-.28-.16c-.03-.01-.42-.18-.46-.19a9.654,9.654,0,0,1-2.63-.92,5.053,5.053,0,0,1-2.44-2.28l-4.27.08c-1.22.22-1.26,4.53,1.29,4.98a2.583,2.583,0,0,1,1.29-1.53c.49.63,1.13.87,1.64,1.54Z",
  fill: "#a7b7b6",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M150.27,68.95l.84,3.76h-1.88a6.117,6.117,0,0,1,.42-1.88c.23-.92-.01-1.42.62-1.88Zm-7.31,7.52h.83c0-2.28-.36-3.51.84-4.39a22.939,22.939,0,0,1,1.88,4.39h1.88a11.93,11.93,0,0,1,.63-2.72h2.29c.21.88.42,1.82.63,2.72h1.05a78.613,78.613,0,0,1-2.3-9.19h-1.05c-.12,1.44-1.86,7.09-2.01,8.89a.445.445,0,0,0,.17.3,20.487,20.487,0,0,1-1.32-2.69c-.74-1.85-1.57-2.23-.87-3.41.2-.35.44-.71.65-1.05.45-.7.85-1.38,1.29-2.04-1.35,0-.93-.14-2.2,1.76a12.247,12.247,0,0,1-1.56,2.41V67.28h-.83Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M108.38,38.77c-.04.96.91,3.37,1.07,4.74a12.778,12.778,0,0,1,.01,3.09,23.9,23.9,0,0,0-.52,2.44c3.38.42,5.28-.54,4.3-4.06-.66-2.36-2.2-4.5-3.04-6.62l-1.82.41Z",
  fill: "#a97252",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M126.52,29.42c1.5-.71,2.58-4.28,1.43-6.26-1.7-.02-2.25,1.91-4.84,3.39-3.06,1.74-5.25,1.3-6.54,1.88,1.17.72,3.38.83,4.85,1.04a12.838,12.838,0,0,0,4.01-.02c1.28-.26.82-.28,1.09-.03Z",
  fill: "#cdcfd1",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M236.8,70.62c0,5.69.29,4.64-1.68,4.59l-.03-1.87c-.01-.72-.18-1.07-.18-2.09,0-1.28.21-1.53.21-2.72,1.8,0,1.54.08,1.59,1.4a4.315,4.315,0,0,1,.09.69Zm-3.35,6.06c5.68,0,4.81.61,4.81-7.73,0-2.17-2.43-1.67-4.81-1.67Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M176.6,73.12h-1.04a20.614,20.614,0,0,0,.42-2.29h.83C176.81,71.99,176.6,72.07,176.6,73.12Zm-1.67-3.55c-1.01,0-1.46-.14-1.46.63s.53.63,1.25.63a11.5,11.5,0,0,0-.41,2.29h-1.26v1.26h1.05c-.07.8-.36,1.5-.42,2.3h1.25a6.742,6.742,0,0,0,.42-2.3h.84c0,1.16-.19,1.39-.21,2.3h1.25a21.23,21.23,0,0,0,.42-2.3h1.25V73.12h-1.04a11.413,11.413,0,0,0,.21-2.29h1.25V69.57h-.84c0-1.05.21-1.13.21-2.29h-1.25a6.531,6.531,0,0,1-.16,1.51c-.21.88-.12.76-1.09.78.02-.9.2-1.14.2-2.29h-1.25c0,1.16-.21,1.24-.21,2.29Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M128.74,33c-1.77.12-4.92-.15-5.19-.11a1.239,1.239,0,0,0-1.1.83c1.74,1.15,2.39,2.42,3.62,4.48a30.838,30.838,0,0,0,5.09-1.72,2.726,2.726,0,0,0,1.45-3.57c-.22-.6.05-.26-.83-.48a.493.493,0,0,1-.15-.03l.03-.73-.41.58c-.01.01-.24.34-.25.35a4.176,4.176,0,0,1-.75.7,4.427,4.427,0,0,1-1.77.92,15.057,15.057,0,0,1-4.34-.36.94.94,0,0,1-.45-.21c1.39-.65.53-.59,2.33-.36C126.89,33.39,128.11,33.64,128.74,33Z",
  fill: "#d2e6e4",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M221.12,68.53H223v6.89h-1.88Zm-1.46-.63v8.15c0,1,1.4.63,3.97.63.64,0,.83-.62.83-1.26,0-2.18.24-6.22-.2-8.14-.84,0-1.68,0-2.52-.01-.96-.01-2.08-.28-2.08.63Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M247.45,68.53h1.68v2.92h-1.68Zm-1.46-.63v4.6c3.75,0,3.14-.6,3.14,2.92h-1.68V73.75h-1.46c0,3.31-.3,2.97,1.88,2.93.83-.01,1.67,0,2.51,0a38.9,38.9,0,0,0,0-9.4C248.37,67.28,245.99,66.88,245.99,67.9Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M128.71,56.83a10.1,10.1,0,0,0,2.44,1.78l2.1,1.05a3.234,3.234,0,0,1,.4.22c.33.23.13.05.35.32-2.01,1.16-2.37.45-4.13-.72-.5-.34-3.2-2.22-3.43-2.74,2.23-.84,3.97-2.56,4.86-3.07-.68,1.89-2.09,2.27-2.59,3.16Zm1.12-2.87a46.9,46.9,0,0,1-4.37,2.72,9.765,9.765,0,0,0,2.04,1.81c.54.34,1.89.98,2.08,1.44,3.17.97,1.19,2.14,5.18.2.9-.44,1.08-.45,1.5-1.11-.84-.11-.86-.28-1.5-1.3-.69-1.1-3.15-4.05-2.94-5.21a21.8,21.8,0,0,0-1.99,1.45Z",
  fill: "#d2e6e4",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M197.29,76.68c5.26,0,3.84,1.31,3.97-7.53.03-1.88.72-1.87-1.46-1.87v8.14h-1.67V67.28h-1.67C196.93,69.52,195.55,76.68,197.29,76.68Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44",
  "data-name": "Path 44",
  d: "M213.81,68.11v7.31c0,1.74,1.38,1.26,4.59,1.26a10.253,10.253,0,0,0,.21-3.35c-1.77,0-.6.36-1.46,0v2.09h-1.88c.45-.79.21-5.65.21-6.89h1.67v1.88h1.46c0-3.86.79-3.13-3.97-3.13A.793.793,0,0,0,213.81,68.11Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_45",
  "data-name": "Path 45",
  d: "M185.38,76.68h1.46l.23-3.57,1.45,3.57h1.67c-.15-.32-.35-.79-.51-1.17-1.74-4.17-1.93-2.98-.72-5.91.28-.66.68-1.67,1.02-2.32h-1.67l-1.39,3.41a.7.7,0,0,1-.08.14V67.28h-1.46v9.4Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_46",
  "data-name": "Path 46",
  d: "M180.16,68.32l-.1,1.94c.2,1.76.1,4.47.1,6.42h1.46l.22-3.36.65,1.44c.23.59.5,1.34.8,1.92h1.47c-.13-1.45-1.89-3.81-1.89-5.02,0-.64,1.58-3.18,1.68-4.38h-1.47l-1.46,3.34V67.28h-1.67a5.574,5.574,0,0,1,.21,1.04Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M117.48,22.55c-.89-1.3-.49-1.56.4-2.48C120.53,20.27,120.28,22.94,117.48,22.55Zm1.91-3.84c.43.76.54.43.74,1.12-1.86-1.01-1.9-1.17-4.06-.49l.48.52c-.07.99-.15.75-.46,1.43l-1.35,2.32c3.67-.35,7.29-1.39,11.32-1.44l-.71-2.18c-.32-.43-.16.65-.32-.69.15,1.02.08.44-.47.71l-1.29-.7c-.75-.34-1.11-.33-1.55.02-.22-.22-.18-.06-.39-.43-.27-.48-.17.33-.19-.65-.11.42-.23.37-.24.39l-.31.47-1.2-.4Z",
  fill: "#d5d8d8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_48",
  "data-name": "Path 48",
  d: "M91.96,76.47h.84V69.78c.59.44.4.67.59,1.5l1.08,5.19h.83a19.435,19.435,0,0,1,.63-3.35,18.419,18.419,0,0,0,.63-3.34l.21,6.69h.83V67.28c-1.32,0-1.08-.42-1.79,3.22-.17.87-.23,1.13-.41,1.88a13.131,13.131,0,0,0-.31,2c-.51-.38-.49-.81-.67-1.62-.11-.53-.23-1.35-.37-1.94-.86-3.62-.15-3.54-2.09-3.54v9.19Z",
  fill: "#374496",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M208.37,67.9c0,3.44-.29,2.54,1.41,4.24s1.52.25,1.52,3.28h-1.67V73.54h-1.26c0,3.84-.75,3.14,3.76,3.14.51,0,.53-.15.71-.56.2-.44.06-.38.08-1.08.03-1.07.23-1.42-.32-2.17a11.843,11.843,0,0,0-2.97-2.67V68.53h1.67c0,1.69-.14,1.67,1.04,1.67.84,0,.63-.59.63-2.09,0-1.22-1.9-.83-3.97-.83-.48,0-.63.14-.63.62Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M81.72,68.95a20.385,20.385,0,0,0,.83,3.76H80.67c.02-.85.6-3.43,1.05-3.76Zm-6.48,7.52h4.6a18.877,18.877,0,0,0,.42-2.72h2.5c.09.99.54,1.63.63,2.72h.84a8.953,8.953,0,0,0-.45-2.28c-.22-.7-.41-1.48-.63-2.29l-1.01-4.62H81.09c-.08.94-1.73,6.58-1.88,8.35a9.2,9.2,0,0,0-3.13-.21V67.28h-.84Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M94.82,43.5c.49,0,.1-.04.41.04a4.089,4.089,0,0,1,2.07,1.58c.81-.33,1.68-1.43,3.26-2.46a13.866,13.866,0,0,1,3.73-2.07c.93.72.84,1.26,1.21,2.06a2.252,2.252,0,0,0,.25.46l.12.15a1.109,1.109,0,0,0,.12.16,1.55,1.55,0,0,0,.13.17,30.309,30.309,0,0,0-1.04-4.3,4.5,4.5,0,0,0-.68-1.37c-.03-.05-.13-.19-.16-.23l-.79-.83c-.77.41-2.85,3.23-3.6,4.06-2.84,3.16-3.55,1.68-5.03,2.58Z",
  fill: "#aabcbb",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M214.43,47.02v2.71h8.99V47.02C222.65,46.97,215.1,46.97,214.43,47.02Z",
  fill: "#293892",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M96.49,32.58a4.4,4.4,0,0,0,3.35,2.56c5.5-1.37,3.65-1.31,5.52-4.17a6.627,6.627,0,0,0,1.2-1.86c-2.81.38-4.11,3.52-10.07,3.47Z",
  fill: "#cdcfd1",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M226.97,76.68h1.47c.17-.73.24-1.58.41-2.31.3-1.24,1.08-6.29,1.47-7.09h-1.68c0,2.22-.83,4.15-.83,6.26h-.21c0-2.14-.84-4.07-.84-6.26H225.3l.79,4.64C226.44,73.54,226.61,75.13,226.97,76.68Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M66.88,75.42H65.63V72.29a6.194,6.194,0,0,1,2.5.21C68.38,73.57,68.8,75.42,66.88,75.42Zm.42-4.38H65.63V68.32c2.03,0,2.5-.16,2.5,1.88a.8.8,0,0,1-.83.84Zm-2.51,5.43c2.91,0,3.91.42,4.45-2.04.32-1.42-.24-2-.9-2.98,1.45-2.15.1-4.17-.83-4.17H64.79v9.19Z",
  fill: "#2d3b94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M27.8,71.25H25.92V68.32H27.8c.67,0,1.04.76,1.04,1.46S28.47,71.25,27.8,71.25Zm-2.72,5.22h.84V72.5c2.3,0,1.5.23,2.93,3.33.37.8.12.64,1.25.64a19.164,19.164,0,0,0-1.89-4.18c2.07-1.09,1.6-3.59.92-4.46-.11-.14.07-.55-1.54-.55H25.08Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M106.59,71.25h-1.88V68.32h1.88c.59,0,1.04.72,1.04,1.25C107.63,70.3,107.33,71.25,106.59,71.25Zm-2.72,5.22h.84V72.5h1.46c.2.74.73,1.3,1.05,2.3.65,2.1.78,1.67,1.67,1.67-.29-.61-.55-1.46-.83-2.1a10.666,10.666,0,0,0-1.05-2.08c2.12-1.12,1.66-4.29.45-4.84a14.789,14.789,0,0,0-3.59-.17v9.19Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M155.91,71.25h-1.67V68.32h1.88c.6,0,1.05,1.01,1.05,1.46,0,.59-.67,1.47-1.26,1.47Zm-2.5,5.22h.83V72.5h1.46c.13.47.6,1.27.84,1.88.25.64.54,1.48.84,2.09h1.04c-.48-.92-.77-2.08-1.88-4.18,2.24-1.18,1.78-5.01-.42-5.01h-2.71v9.19Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M6.9,76.47h.83V69.78a3.705,3.705,0,0,1,.9,1.61c.3.74.48,1.29.77,1.95,1.26,2.83.65,3.09,2.09,3.13V67.28h-.62l-.09,5.37a2.446,2.446,0,0,1-.12,1.1l-.78-1.52c-.49-1.27-1.86-4.04-1.94-4.95H6.9Z",
  fill: "#333a94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M121.43,68.95V70.2c0,2.43,3.55,1.71,3.55,3.76a1.467,1.467,0,0,1-1.85,1.46c-1.87-.71-.2-1.94-1.91-2.09a4.356,4.356,0,0,0,.41,2.31,2.1,2.1,0,0,0,3.51.15,2.986,2.986,0,0,0-.72-4.4c-.94-.46-2.36-.53-2.36-1.82,0-1.34,2.49-2.25,2.71.42.36-.08.58.03.73-.43a2.223,2.223,0,0,0-2.19-2.49,1.891,1.891,0,0,0-1.88,1.88Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M30.51,69.78c0,2.8,3.77,2.16,3.77,4.18a1.415,1.415,0,0,1-1.47,1.46c-1.4,0-1.41-.98-1.67-2.09h-.63a3.827,3.827,0,0,0,.41,2.31c1.6,2.48,5,.12,3.93-2.87a2.381,2.381,0,0,0-1.59-1.56c-1.32-.59-1.91-.42-1.91-1.84a1.246,1.246,0,0,1,2.42-.34c.38.84-.05.69.71.96,1.5-2.65-3.97-4.9-3.97-.21Z",
  fill: "#2d3b94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M88.2,73.54c0,3.14-2.87,2.28-2.93-.21-.4.04-.83-.01-.83.42,0,3.41,4.59,4.34,4.59,0a2.817,2.817,0,0,0-.36-1.51c-.81-1.38-3.19-1.11-3.19-2.67,0-1.49,2.49-2.26,2.72.42.86-.2.67-.08.71-.53a2.539,2.539,0,0,0-.29-1.14c-1.29-2.7-4.88-.72-3.72,2.45.67,1.81,3.3,1.38,3.3,2.77Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M54.55,69.57c0,3.56,3.55,1.99,3.55,4.39a1.411,1.411,0,0,1-2.77.47c-.36-.92.2-1-.99-1.1,0,4.32,4.6,4.57,4.6.21,0-1.81-1.69-2.26-2.43-2.59-.72-.32-.58-.38-1.13-.75V68.74c.11-.04,2.45-1.73,2.51,1.25,2.11-.17.08-2.92-1.25-2.92-1.42,0-2.09,1.06-2.09,2.5Z",
  fill: "#2a398d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M47.23,69.16c0,4.37,2.87,2.16,3.45,4.5.54,2.17-2.76,2.88-3.03-.33-.97.08-1.06.49-.29,1.96a2.085,2.085,0,0,0,4.05-.7c0-1.59.23-2.63-1.48-3.32-1.91-.78-1.86-.58-1.86-2.11,0-1.06,2.45-1.75,2.51.83.71-.16.73-.04.8-.62.16-1.25-2.06-3.55-3.65-1.59a2.447,2.447,0,0,0-.5,1.38Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M109.31,75c0,.59.27.8,0,1.47h4.39V75.42h-3.56V72.29c.69,0,1.45.04,2.12.02,1.09-.02,1.01.05,1.23-.86-1.14-.54-3.35.36-3.35-.83v-2.3h3.56V67.28h-4.39V75Z",
  fill: "#2b3592",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M19.85,76.47h4.39V75.42H20.69V72.29h3.14V71.25H20.69V68.32h3.34V67.28H19.85Z",
  fill: "#2a398d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M59.77,76.47h4.18V75.42H60.61V72.29h3.13V71.25H60.61V68.32h3.34V67.28H59.77Z",
  fill: "#2b3592",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  d: "M131.82,52.51c-.21,1.16,2.25,4.11,2.94,5.21.64,1.02.66,1.19,1.5,1.3.57-.12.34-.05.87-.48a5.149,5.149,0,0,0,.75-.72,2.763,2.763,0,0,0,.87-1.98l-2.92.39c-.61-1.41-2.53-3.97-3.75-4.44Z",
  fill: "#f5fdfc",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  d: "M70.22,76.47H74.4V75.42H71.06V72.29h3.13V71.25H71.06V68.32h3.13V67.28H70.22Z",
  fill: "#2b3592",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M164.69,68.95c.55.4.5.92.71,1.79a13.167,13.167,0,0,0,.54,1.97h-1.88C164.09,71.49,164.66,70.31,164.69,68.95Zm-2.51,7.52h1.05c.02-1.05.39-1.68.42-2.72h2.5c.24,2.79.66,2.7,1.47,2.72a41.659,41.659,0,0,0-1.14-4.71l-.88-3.51c-.15-.62-.01-.97-.7-.97-.65,0-.51.24-.67.79Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M1.46,73.54c0,4.25,4.39,4.19,4.39,0V67.28H5.02v6.68a1.367,1.367,0,1,1-2.72,0V67.28H1.46Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M100.53,68.74a22.106,22.106,0,0,1,1.04,3.97H99.69C99.8,71.42,100.4,70.25,100.53,68.74Zm-2.51,7.73c1.11-.03.82.21,1.23-1.91.14-.77.02-.74.84-.83.34-.04,1.28.02,1.69.02a18.434,18.434,0,0,1,.63,2.72h1.04c-.45-.96-1.31-5.24-1.76-6.81a11.9,11.9,0,0,1-.53-2.38h-1.05a10.422,10.422,0,0,1-.47,2.24l-1.11,4.53a19.494,19.494,0,0,0-.51,2.42Z",
  fill: "#2d3b94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M126.65,73.96c0,3.4,4.39,3.97,4.39-.42V67.28h-.83c0,2.28.31,6.42-.42,7.93-2.98.7-2.3-.53-2.3-7.93h-.84v6.68Z",
  fill: "#333a94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M118.58,57.26c1.5.16,1.91.24,2.39-1.11a19.647,19.647,0,0,0,1.25-7.39l-.37-1.41c-1.38.28-1.15.67-1.25,2.18C120.28,54.29,119.7,53.82,118.58,57.26Z",
  fill: "#b0932d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M43.89,68.32h.21a7.875,7.875,0,0,0,.35,2.16c.21.79.31,1.48.48,2.23H43.05l.84-4.39Zm-2.51,8.15c1.28-.03.91-.32,1.46-2.72h2.3a8.183,8.183,0,0,1,.63,2.72h1.05L45.7,72.15c-.24-.83-.35-1.56-.58-2.34a14.86,14.86,0,0,1-.6-2.53c-.6.01-.95-.47-1.38,1.55l-1.76,7.64Z",
  fill: "#333a94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  d: "M16.3,76.47h.84c.07-.82,2.09-7.68,2.09-9.19-1.25.1-.7.44-1.49,3.31L16.51,74.8c0-1.7-1.43-6.19-1.46-7.52h-.84C14.21,68.46,15.93,74.86,16.3,76.47Z",
  fill: "#333a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  "data-name": "Path 77",
  d: "M242.86,69.57c.24.67-.46.3.62.42v6.69h1.47v-9.4h-1.47a4.879,4.879,0,0,1-.24,1.22c0,.02-.12.45-.13.49l-.25.58Z",
  fill: "#263a91",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M230.94,76.68h1.47v-9.4h-1.47Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  d: "M128.71,56.83c.5-.89,1.91-1.27,2.59-3.16-.89.51-2.63,2.23-4.86,3.07.23.52,2.93,2.4,3.43,2.74,1.76,1.17,2.12,1.88,4.13.72-.22-.27-.02-.09-.35-.32a3.235,3.235,0,0,0-.4-.22l-2.1-1.05a10.1,10.1,0,0,1-2.44-1.78Z",
  fill: "#aabcbb",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  d: "M121.43,36.37l5.67,7.8c.69.32.17.3,1,.64-.32-2.07-3.75-6.43-5.08-8.16-1.4-1.82-1.4-2.18-2.46-2.1.25.84.6.98.87,1.82Z",
  fill: "#865c46",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M115.49,47.79l4.43-.37a6.106,6.106,0,0,0-.79-2.59l-3.9.16a11.182,11.182,0,0,1,.11,1.19Z",
  fill: "#b0932d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M114.11,68.32h1.88v8.15h.84V68.32h1.88V67.28h-4.6Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  d: "M37.41,68.32h1.88v8.15h.84V68.32h1.88V67.28h-4.6Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M158.42,68.32h1.88v8.15h.84V68.32h1.67V67.28h-4.39Z",
  fill: "#2d3b94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M124.4,41.33a3.7,3.7,0,0,0-.77-1.11,18.519,18.519,0,0,1-2.12-3.41,3.167,3.167,0,0,1-.8-.98,4.652,4.652,0,0,0-.32-.5c-.31-.4-.2-.26-.39-.41-.31.67.78,3.21,1.17,4.02.26.55.55,1.19.82,1.85.26.63.43,1.37.9,1.71l1.39-1.05C124.3,41.38,124.36,41.37,124.4,41.33Z",
  fill: "#aabcbb",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M112.16,40.52a1.137,1.137,0,0,1,.36.34l1.36,3.06a40.9,40.9,0,0,1,.75,4.24c1.04-3.34-1.02-6.73-2.01-9.11a11.794,11.794,0,0,0-1.51-2.37l-1,.22c.46.98,1.97,2.6,2.05,3.62Z",
  fill: "#a8976c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M131.86,49.69a11.329,11.329,0,0,0-2.14-2.47c-.82-.47-.93-.82-1.8-1.11a30.861,30.861,0,0,0,2.91,5.68C131.69,51.18,131.57,50.8,131.86,49.69Z",
  fill: "#f5f6f6",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M128.74,33c-.63.64-1.85.39-2.72.29-1.8-.23-.94-.29-2.33.36a.94.94,0,0,0,.45.21,15.057,15.057,0,0,0,4.34.36,4.427,4.427,0,0,0,1.77-.92,4.176,4.176,0,0,0,.75-.7c.01-.01.24-.34.25-.35l.41-.58.11-1.21c-.89.46-.66.57-1.52,1.37A9.281,9.281,0,0,1,128.74,33Z",
  fill: "#f5fdfc",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  "data-name": "Path 89",
  d: "M35.95,76.47h.83V67.28h-.83Z",
  fill: "#2c3a8b",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_90",
  "data-name": "Path 90",
  d: "M12.75,76.47h.83V67.28h-.83Z",
  fill: "#2d3b94",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M101.67,59.08l.38-.12c-.51-.67-1.15-.91-1.64-1.54a2.583,2.583,0,0,0-1.29,1.53c-2.55-.45-2.51-4.76-1.29-4.98l4.27-.08.31-.55-5.29.06c-.99,2.66-.39,5.29,1.74,6.02,1.22-.47.54-.54,1.46-1.18.67.23.72.44,1.35.84Z",
  fill: "#152227",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_92",
  "data-name": "Path 92",
  d: "M106.91,43.99c1.04-1.74.19-4.57-.85-6.25-.53-.85-.66-.95-1.92-.93.54,1.02,1.26,1.76,1.86,3.07a10.615,10.615,0,0,1,.91,4.11Z",
  fill: "#a8976c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_93",
  "data-name": "Path 93",
  d: "M110.16,10.48a2.731,2.731,0,0,1,1.3,2.84s-.06.89-1.15.35c-1.34-.67-.9-2.45-.61-3.54l.46.35Zm-.73-.73c-.23.86-.81,1.93-.42,3.1.26.76,1.44,1.8,2.48,1.26,1.44-.74.28-4.26-2.06-4.36Z",
  fill: "#170402",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  "data-name": "Path 94",
  d: "M119.78,44.72a5.215,5.215,0,0,0,.8,2.4,9.27,9.27,0,0,0,2.49-.93l-.83-2.1-.48.14s1.46.24-.1.91a6.5,6.5,0,0,1-1.49.37C119.93,43.99,120.14,45.25,119.78,44.72Z",
  fill: "#b0932d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  d: "M125.97,39.65c.07-1.05-1.03-2.65-1.56-3.34-.57-.75-1.8-2.25-2.73-2.18Z",
  fill: "#a8976c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_96",
  "data-name": "Path 96",
  d: "M111.46,13.32c-.03-.04-.08-.14-.09-.11l-.41-1.27a4.457,4.457,0,0,0-1.01-1.03c-.13-.94-.06-.11.21-.43l-.46-.35c-.29,1.09-.73,2.87.61,3.54C111.4,14.21,111.46,13.32,111.46,13.32Z",
  fill: "#c54e48",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  d: "M108.2,24.19c-.44.04-.68.19-.92-.23a.645.645,0,0,1,.08-.81c1.04-.39,1.31.14.84,1.04Zm-1.35-.14c.98,1.1,1.7,1,2.66.05.12-1.57-.51-1.76-1.89-1.91-.6.82-.77.54-.77,1.86Z",
  fill: "#080706",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_98",
  "data-name": "Path 98",
  d: "M118.49,21.98c-1.62.38-1.83-1.44.01-1Zm-1.01.57c2.8.39,3.05-2.28.4-2.48C116.99,20.99,116.59,21.25,117.48,22.55Z",
  fill: "#170402",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  d: "M239.3,73.54h2.93v-.62c0-.49-.15-.63-.63-.63h-2.3v1.25Z",
  fill: "#2a398d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M122.91,44.31a3.809,3.809,0,0,0,.68,1.57,8.747,8.747,0,0,0,2.67-2l-.37-.33c.18.81.29.03-.07.43a3.28,3.28,0,0,1-.78-.49c-.46.2-.22.12-.54.37-.94.72-.96.67-1.59.45Z",
  fill: "#b0932d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M122.91,44.31c.63.22.65.27,1.59-.45.32-.25.08-.17.54-.37a3.28,3.28,0,0,0,.78.49c.36-.4.25.38.07-.43l-.72-1.29a18.139,18.139,0,0,1-2.5,1.43l.24.62Z",
  fill: "#d3b14d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M100.74,47.42c.29.93,1.22,2.11,1.35,2.82l.19-3.04Z",
  fill: "#eaf6f6",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M105.75,23.81c.49-.61.37-1.26.89-2.02.64-.91,1.2-.57,2.48-.71C107.35,19.66,105.52,21.52,105.75,23.81Z",
  fill: "#0a0e11",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_104",
  "data-name": "Path 104",
  d: "M116.07,19.34c2.16-.68,2.2-.52,4.06.49-.2-.69-.31-.36-.74-1.12-.82-.07-.72-.39-1.7-.29a1.967,1.967,0,0,0-1.62.92Z",
  fill: "#0a0e11",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_105",
  "data-name": "Path 105",
  d: "M119.78,44.72c.36.53.15-.73.39.79a6.5,6.5,0,0,0,1.49-.37c1.56-.67.1-.91.1-.91l-1.98.49Z",
  fill: "#d3b14d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  d: "M107.36,23.15a.645.645,0,0,0-.08.81c.24.42.48.27.92.23.47-.9.2-1.43-.84-1.04Z",
  fill: "#f5f6f6",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M118.49,21.98l.01-1C116.66,20.54,116.87,22.36,118.49,21.98Z",
  fill: "#edf1ef",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M111.46,13.32a2.731,2.731,0,0,0-1.3-2.84c-.27.32-.34-.51-.21.43a4.457,4.457,0,0,1,1.01,1.03l.41,1.27c.01-.03.06.07.09.11Z",
  fill: "#ead7d9",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  d: "M152.91,58.78V29.96h8.35V58.78Zm9.51-31.43H151.76a1.786,1.786,0,0,0-1.79,1.78V59.61a1.786,1.786,0,0,0,1.79,1.78h10.66a1.784,1.784,0,0,0,1.78-1.78V29.13a1.784,1.784,0,0,0-1.78-1.78Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M210.25,56.04V32.71a5.371,5.371,0,0,0-5.35-5.36h-8.88V61.39h8.88A5.369,5.369,0,0,0,210.25,56.04Zm-2.94-23.1V55.81a2.977,2.977,0,0,1-2.97,2.97h-5.38V29.96h5.38a2.979,2.979,0,0,1,2.97,2.98Z",
  fill: "#293996",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_62",
  "data-name": "Group 62"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M22.69,62.05H35.11c-2.23-3.54-11.7-16.53-11.7-18.37.67-.25,10.78-13.78,11.91-15.25H29.05c-2.17,0-3.66.06-5.8.06-.43.82-.68.9-1.16,1.75-2.67,3.83-5.33,7.58-8.09,11.34-2.47,3.13-2.01,2.58-.34,5.15,1.92,3.26,7.44,12.26,9.03,15.32Z",
  fill: "#04acec",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M0,61.43v.62H9.61c.74,0,.8-.01,1.22,0,.03-.21.02-.35.04-.6.66-9.39.93-23.64,1.67-33.17-3.81-.01-6.29,0-10.74-.05C1.61,38.83.2,56.95,0,61.43Z",
  fill: "#00aeed",
  fillRule: "evenodd"
}))));

var SvgKknLogo = function SvgKknLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250.665,
    height: 76.745,
    viewBox: "0 0 250.665 76.745",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKknLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kkn-logo.55f56686.svg";
export { ForwardRef as ReactComponent };